import React from "react";
import { connect } from "react-redux";
import OrdersTable from "../Shared/OrdersTable";
import { useHistory } from "react-router-dom";

const NoteQueue = (props) => {
  const { orders, hpMode } = props;
  const history = useHistory();

  if (!hpMode) {
    history.push("/LineInfo");
  }

  if (orders) {
    return (
      <OrdersTable
        parent="Note Queue"
        isChunkSorted={true}
        orders={orders.filter((o) => o.status === 1 || o.status === 2)}
      />
    );
  } else {
    return <div>Loading...</div>;
  }
};

const mapStateToProps = (state) => ({
  orders: state.order.orders,
  hpMode: state.system.hpMode,
});

export default connect(mapStateToProps, {})(NoteQueue);
